/**
 * Create Aggregate Command
 * 
 * Command for creating new DDD Aggregate tactical models.
 * Includes validation and business rule enforcement.
 */

import { ICommand, BaseCommand } from '@swoft/core';

export interface CreateAggregatePayload {
  aggregateId?: string; // Optional AR-XXX identifier, auto-generated if not provided
  boundedContextId: string;
  name: string;
  description?: string;
  responsibility: string;
  rootEntity: {
    name: string;
    description?: string;
    properties: Array<{
      name: string;
      type: string;
      isRequired: boolean;
      description?: string;
    }>;
  };
  initialValueObjects?: Array<{
    name: string;
    description?: string;
    properties: Array<{
      name: string;
      type: string;
      isRequired: boolean;
      description?: string;
    }>;
  }>;
  initialBusinessInvariants?: Array<{
    description: string;
    rule: string;
    severity: 'error' | 'warning';
  }>;
  initialDomainEvents?: Array<{
    name: string;
    description?: string;
    triggers: string[];
  }>;
  ubiquitousLanguageTerms?: string[];
}

export class CreateAggregateCommand extends BaseCommand implements ICommand {
  constructor(
    public readonly payload: CreateAggregatePayload,
    authSessionId: string,
    initiatedByPersonId: string,
    correlationId?: string
  ) {
    super(authSessionId, initiatedByPersonId, correlationId);
  }
}